import { ApiParameter, API_URL_CURRENT_FRAGMENT, get, patch, post } from "@insite/client-framework/Services/ApiService";

export interface ValidateCartApiParameter extends ApiParameter {
    lines: any[];
    orderNumber?: string;
    shipToCustNbr?: string;
    shipToRegion?: string;
}

export interface SplitOrderParameter extends ApiParameter {
    t: string;
}

const customValidateCartUrl = "api/v1/customvalidatecart";

const splitOrderUri = "api/v1/customsplitorder";

export function validateCart(parameter: ValidateCartApiParameter) {
    return post<any>(`${customValidateCartUrl}/validateCart/`, parameter);
}

export function splitOrder(parameter: SplitOrderParameter) {
    return get<any>(`${splitOrderUri}/${API_URL_CURRENT_FRAGMENT}`, parameter);
}

export function removeValidationStatus(parameter: ValidateCartApiParameter) {
    return patch<any>(`${customValidateCartUrl}/removevalidationstatus`, parameter);
}

export function checkCartValidation() {
    return get<any>(`${customValidateCartUrl}/checkCartValidation?t=${Date.now()}`);
}
